import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RequireAuth from "./components/RequireAuth";
import Login from "./components/Login/Login";
import PasswordReset from "./components/Login/PasswordReset";
import { useState } from "react";

function App() {
  const [user, setUser] = useState("");
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/password/reset" element={<PasswordReset />} />
        <Route path="/password/reset/:token" element={<PasswordReset />} />

        <Route path="/:filter" element={<RequireAuth user={user} setUser={setUser} />}/>
        <Route path="/" element={<RequireAuth user={user} setUser={setUser} />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
